import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import './Preloader.scss';

const Preloader = () => {
  const siteLoaded = useSelector((state) => state.app.loading);

  const [shouldRender, setShouldRender] = useState(true);
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    if (siteLoaded) {
      setShouldRender(true);
      setFadingOut(false);
    } else if (shouldRender) {
      setFadingOut(true);
      const timeout = setTimeout(() => {
        setShouldRender(false);
      }, 500);

      return () => clearTimeout(timeout);
    }
  }, [siteLoaded, shouldRender]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div className={`preloader ${fadingOut ? 'fade-out' : ''}`}>
      <div className='preloader__grid'>
        <div className='item'></div>
        <div className='item'></div>
        <div className='item'></div>
        <div className='item'></div>
      </div>
    </div>
  );
};

export default Preloader;
